import * as Localization from "expo-localization"
import i18n from "i18n-js"
import en from "./en"
import id from "./id"
import vi from "./vi"
import es from "./es"
import * as yupLocale from "./yup"
import { setLocale } from "yup"

let deviceLocale = 'id';
const deviceLocales = Localization.locale.toLowerCase().replace('_', '-').split('-');
deviceLocale = { in_ID: 'id' }[Localization.locale]
  || {
    en: 'en', es: 'es', id: 'id', vi: 'vi', vn: 'vi'
  }[deviceLocales[0]] || deviceLocale;

i18n.fallbacks = true
i18n.defaultLocale = "id"
i18n.translations = { en, id, vi, es }

i18n.locale = deviceLocale

const locale = i18n.locale.split('-')[0]
if (yupLocale[locale])
  setLocale(yupLocale[locale])

/**
 * Builds up valid keypaths for translations.
 * Update to your default locale of choice if not English.
 */
type DefaultLocale = typeof en
export type TxKeyPath = RecursiveKeyOf<DefaultLocale>

type RecursiveKeyOf<TObj extends Record<string, any>> = {
  [TKey in keyof TObj & string]: TObj[TKey] extends Record<string, any>
    ? `${TKey}` | `${TKey}.${RecursiveKeyOf<TObj[TKey]>}`
    : `${TKey}`
}[keyof TObj & string]
